import AgendaItem, {
    AgendaRenderPriority,
    AgendaItemType,
} from 'mini-agenda/lib/schema/AgendaItem';
import getAgendaHeight from './getAgendaHeight';
/**
 * Constants defining heights of the different types of agenda items
 */
const EVENT_CARD_HEIGHT = 68;
const ALL_DAY_CARD_HEIGHT = 48;
const DAY_MONTH_SEPARATOR_HEIGHT = 64;

function markPriorityForAgendaItems(agendaItems: AgendaItem[], anchorKey: string) {
    let isAnchorKeySeen = false;
    let currentTotalHeight = 0;

    let itemHeight = 0;

    const agendaHeight = getAgendaHeight();
    let availableHeight = 0;

    agendaHeight &&
        agendaItems?.forEach(item => {
            // When this method is called, by default all items should get delayed priority.
            let priority = AgendaRenderPriority.DELAYED;

            /**
             * First thing, we need to find the item where anchor key is seen
             * As any item after anchor key is marked with normal priority
             *  till the time available height is present
             */
            if (anchorKey === item.id) {
                isAnchorKeySeen = true;
            }

            availableHeight = agendaHeight - currentTotalHeight;

            if (isAnchorKeySeen && availableHeight > 0) {
                switch (item.type) {
                    case AgendaItemType.Event:
                        itemHeight = item.event.IsEffectiveAllDayEvent
                            ? ALL_DAY_CARD_HEIGHT
                            : EVENT_CARD_HEIGHT;
                        break;
                    case AgendaItemType.DayMonthSeparator:
                        itemHeight = DAY_MONTH_SEPARATOR_HEIGHT;
                }

                priority = AgendaRenderPriority.NORMAL;
                currentTotalHeight = currentTotalHeight + itemHeight;
            }

            item.priority = priority;
        });

    return agendaItems;
}

export default markPriorityForAgendaItems;
